import { metricKeys } from '@pulse/metrics';

export const APP_DIMENSIONS = {
  STACK_TRACE: 'stack_trace',
  TAG_KEY: 'tag_key',
  TAG_VALUE: 'tag_value',
  ERROR_INFO: 'error_info',
  PLATFORM: 'platform',
  APP_ID: 'app_id',
  APPLICATION_VERSION: 'application_version',
  DEVICE_NAME: 'device_name',
  EVENT_NAME: 'event_name',
  COUNTRY: 'geo_country',
  ERROR_EVENT_NAME: 'error_event_name',
  PAGE_URL_PATH: 'page_urlpath',
  ANR_REASON: 'anr_reason',
  button_click_id: 'button_click_id',
  button_click_text: 'button_click_text',
  rage_click_page_url: 'rage_click_page_url',
  page_loop_path: 'page_loop_path',
  click_to_error_page_title: 'click_to_error_page_title',
  EXCESSIVE_APP_RESTART_LAST_ACTION: 'app_restart_last_user_action',
  EXCESSIVE_APP_RESTART_SCREEN_TITLE: 'app_restart_last_screen_title',
  PAGE_PATH: 'page_urlpath',
  PAGE_HOST: 'page_urlhost',
  NWR_ENDPOINT: 'network_request_url_host_path',
  NWR_HOST: 'network_request_url_host',
  NWR_PATH: 'network_request_url_path',
  XPATH: 'xpath',
  crash_v2_exception: 'crash_v2_exception',
  crash_v2_message: 'crash_v2_message',
  crash_v2_trace: 'crash_v2_trace',
};

export const FLOW_ERROR_ANALYSIS_ONLY_DIMENSIONS = [APP_DIMENSIONS.ERROR_EVENT_NAME];

export const MAPPED_EVENT_DIMENSIONS = [
  {
    dimension: APP_DIMENSIONS.TAG_KEY,
    header: 'Tag Key',
  },
  {
    dimension: APP_DIMENSIONS.TAG_VALUE,
    header: 'Tag Value',
  },
];

export const APP_ERROR_DIMENSIONS = [
  {
    dimension: APP_DIMENSIONS.STACK_TRACE,
    header: 'Stack Trace',
  },
  {
    dimension: APP_DIMENSIONS.ERROR_INFO,
    header: 'Error Message',
  },
];

export const ECO_ANR_DIMENSIONS = [
  {
    dimension: APP_DIMENSIONS.ANR_REASON,
    header: 'ANR Reason',
  },
];

export const ECO_RAGE_CLICK_DIMENSIONS = [
  {
    dimension: APP_DIMENSIONS.rage_click_page_url,
    header: 'Rage Click Page Url',
  },
  {
    dimension: APP_DIMENSIONS.button_click_text,
    header: 'Element Text',
  },
  {
    dimension: APP_DIMENSIONS.XPATH,
    header: 'Element XPath',
  },
];

export const DPI_APP_CRASHES_V2_DIMENSIONS = [
  {
    dimension: APP_DIMENSIONS.crash_v2_exception,
    header: 'Crash Exception Name (v2)',
  },
  {
    dimension: APP_DIMENSIONS.crash_v2_message,
    header: 'Crash Message (v2)',
  },
  {
    dimension: APP_DIMENSIONS.crash_v2_trace,
    header: 'Crash Stack Trace (v2)',
  },
];

export const DPI_5XX_TO_BACKGROUND_DIMENSIONS = [
  {
    dimension: APP_DIMENSIONS.NWR_PATH,
    header: 'Network Request Url Path',
  },
  {
    dimension: APP_DIMENSIONS.NWR_HOST,
    header: 'Network Request Url Host',
  },
  {
    dimension: APP_DIMENSIONS.NWR_ENDPOINT,
    header: 'Network Request Endpoint',
  },
];

export const DPI_PAGE_LOOPING_DIMENSIONS = [
  {
    dimension: APP_DIMENSIONS.page_loop_path,
    header: 'Page Loop Path',
  },
];

export const DPI_CLICK_TO_WEB_ERROR_DIMENSIONS = [
  {
    dimension: APP_DIMENSIONS.XPATH,
    header: 'Element XPath',
  },
  {
    dimension: APP_DIMENSIONS.click_to_error_page_title,
    header: 'Click to Error Page Title',
  },
];

export const ECO_EXCESSIVE_APP_RESTART_DIMENSIONS = [
  {
    dimension: APP_DIMENSIONS.EXCESSIVE_APP_RESTART_LAST_ACTION,
    header: 'Last Event',
  },
  {
    dimension: APP_DIMENSIONS.EXCESSIVE_APP_RESTART_SCREEN_TITLE,
    header: 'Last Screen Title',
  },
];

export const APP_ERROR_MODAL_EXPLORE_DIMENSIONS = [
  {
    dimension: APP_DIMENSIONS.ERROR_INFO,
    header: 'Error Message',
  },
  {
    dimension: APP_DIMENSIONS.STACK_TRACE,
    header: 'Stack Trace',
  },
];

export const errorMetrics = [
  metricKeys.AppErrors,
  metricKeys.AppCrashSessions,
  metricKeys.mins_with_crash_to_app_startup,
  metricKeys.crash_to_app_startup_success,
  metricKeys.app_crash_to_session_end_success,
];

export const ANRMetrics = [
  metricKeys.anr_count,
  metricKeys.anr_to_app_startup_success,
  metricKeys.mins_with_anr_to_app_startup,
  metricKeys.anr_to_session_end_success,
];

export const rageClickMetrics = [
  metricKeys.rage_click_count,
  metricKeys.user_session_with_rage_click,
  metricKeys.user_session_with_rage_click_percentage,
  metricKeys.users_with_rage_click,
  metricKeys.users_with_rage_click_percentage,
];

export const excessiveAppRestartMetrics = [
  metricKeys.user_session_with_app_restart_percentage,
  metricKeys.excessive_app_restart_count,
  metricKeys.user_session_with_app_restart,
  metricKeys.users_with_app_restart,
  metricKeys.users_with_app_restart_percentage,
];

export const pageLoopingMetrics = [
  metricKeys.page_loop_count,
  metricKeys.user_session_with_page_loop,
  metricKeys.user_session_with_page_loop_percentage,
  metricKeys.users_with_page_loop,
  metricKeys.users_with_page_loop_percentage,
];

export const clickToWebErrorMetrics = [
  metricKeys.click_to_error_success,
  metricKeys.click_to_error_success_rate,
  metricKeys.user_session_with_click_to_error,
  metricKeys.user_session_with_click_to_error_percentage,
  metricKeys.users_with_click_to_error,
  metricKeys.users_with_click_to_error_percentage,
];

export const Nw5xxToAppBackgroundMetrics = [
  metricKeys.nw_5xx_to_app_background_success,
  metricKeys.nw_5xx_to_app_background_init,
  metricKeys.nw_5xx_to_app_background_success_rate,
];

export const appCrashV2Metrics = [
  metricKeys.app_crash_v2_count,
  metricKeys.user_session_with_app_crash_v2,
  metricKeys.user_session_with_app_crash_v2_percentage,
  metricKeys.users_with_app_crash_v2,
  metricKeys.users_with_app_crash_v2_percentage,
];

export const FLOW_PRESET_DEFAULT_DIMENSIONS = [
  APP_DIMENSIONS.DEVICE_NAME,
  APP_DIMENSIONS.APPLICATION_VERSION,
  APP_DIMENSIONS.COUNTRY,
];

// TODO: These dimensions should be from luigi flow meta api, temporary hardcode here
export const FLOW_ERROR_ANALYSIS_STATIC_DIMENSIONS = [
  {
    dimension: 'error_event_name',
    header: 'Error Event',
  },
];

// TODO: These dimensions should be from luigi flow meta api, temporary hardcode here
export const FLOW_NETWORK_REQUEST_STATIC_DIMENSIONS = [
  {
    dimension: 'network_request_url_host',
    header: 'Network Request Url Host',
  },
  {
    dimension: 'network_request_url_path',
    header: 'Network Request Url Path',
  },
];

// TODO: This information should be from luigi flow meta api, temporary hardcode here
export const FLOW_HIDDEN_STATIC_DIMENSIONS = Array.from(
  new Set([...FLOW_ERROR_ANALYSIS_STATIC_DIMENSIONS].map((it) => it.dimension)),
);
